import { createFileRoute } from "@tanstack/react-router";
import { PortalRequestsPage } from "@/features/portalrequests/PortalRequestsPage";

export const Route = createFileRoute("/portal/requests")({ component: PortalRequestsPage });
